import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Injectable()
export class MatPaginatorIntlCust extends MatPaginatorIntl implements OnDestroy {
  // same as original except when page size is 1
  private translationSubscription: Subscription;
  constructor(public translocoService: TranslocoService) {
    super();
    this.translationSubscription = this.translocoService
      .selectTranslateObject('custom-paginator')
      .subscribe((translatedValue) => {
        this.itemsPerPageLabel = translatedValue['items-per-page-label'];
      });
  }

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
  }

  getRangeLabel = function (page: number, pageSize: number, length: number) {
    if (length === 0 || pageSize === 0) {
      return this.translocoService.translate('custom-paginator.x-of-y', { 1: `0`, 2: length });
    }
    if (pageSize === 1) {
      return this.translocoService.translate('custom-paginator.x-of-y', { 1: page + 1, 2: length });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.translocoService.translate('custom-paginator.x-minus-y-of-z', {
      1: startIndex + 1,
      2: endIndex,
      3: length,
    });
  };
}
